import router from "./index";

export default [
  {
    path: "/club",
    component: () => import('../views/Club/Club'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") != "student")
        next();
      else
        router.replace("/home");
    },
    meta: {
      title: '俱乐部'
    },
    children: [
      {
        path: '/',
        redirect: 'ClubList'
      },
      {
        path: 'ClubList',
        component: () => import('../views/Club/ClubList/ClubList'),
        meta: {
          title: '俱乐部列表'
        },
      },
      {
        path: 'AddClub',
        component: () => import('../views/Club/AddClub/AddClub'),
        meta: {
          title: '添加俱乐部'
        },
      },
      {
        path: 'ClubMember',
        component: () => import('../views/Club/ClubMember/ClubMember'),
        meta: {
          title: '俱乐部成员'
        },
      }, {
        path: 'ModifyClub',
        component: () => import('../views/Club/ModifyClub/ModifyClub'),
        meta: {
          title: '修改俱乐部'
        },
      }, {
        path: 'ClubStatistics',
        component: () => import('../views/Club/ClubStatistics/ClubStatistics'),
        meta: {
          title: '俱乐部统计数据'
        },
      },
      // {
      //   path: 'ClubHome',
      //   component: () => import('../views/Club/ClubHome/ClubHome'),
      //   meta: {
      //     title: '俱乐部首页'
      //   },
      // },
    ]
  },
]
